import {
  useMemo,
  useState,
} from 'react';
import orderUsersByActiveStatus from 'pages/Dashboard/utils/userOptions';

type UserStatus = {
  isActive?: boolean;
};

export default function useUserStatusOptions<T extends UserStatus>(options: T[]) {
  const [showInactive, setShowInactive] = useState(false);
  const orderedOptions = useMemo(() => orderUsersByActiveStatus(options), [options]);
  const activeOptions = useMemo(
    () => orderedOptions.filter((option) => option.isActive !== false),
    [orderedOptions],
  );
  const inactiveOptions = useMemo(
    () => orderedOptions.filter((option) => option.isActive === false),
    [orderedOptions],
  );
  const visibleOptions = showInactive ? orderedOptions : activeOptions;
  const inactiveConfig = inactiveOptions.length === 0 ? null : {
    showInactive,
    onToggleShowInactive: () => setShowInactive((current) => !current),
    type: 'user',
    count: inactiveOptions.length,
  };

  return {
    visibleOptions,
    inactiveConfig,
  };
}
